<template>
  <div class="ms-textarea ms-editor flex" :class="{error: errorProvider.isValid, disabled: disabled}">
    <label v-if="label" class="label">{{ label }}</label>

    <div class="flex-row border" :class="{error: errorMessage, disabled: disabled}">
      <textarea
        ref="input"
        v-model="internalText"
        class="ms-textarea-item flex"
        :placeholder="placeholder"
        :disabled="disabled"
        :maxlength="maxLength"
        :rows="rows"
        :readOnly="readOnly"
        :style="styleCustom"
        v-on="listeners"
      />
      <div v-if="errorMessage" class="icon24 error error-icon"></div>
    </div>
    <div v-if="errorMessage" class="error-text">
      {{ errorMessage }}
    </div>
  </div>
</template>
<script>
import msBaseComponent from '@/components/base/MsBaseComponent.vue';
import {useValidateControl} from '@/composables/validateControl.js';

export default {
  name: 'MsTextarea',
  extends: msBaseComponent,
  props: {
    styleCustom: {
      default: null,
      type: String,
    },
    /**
     * V-model bắn ra ngoài binding 2 chiều
     */
    modelValue: {
      default: null,
    },
    /**
     * Hiện thị chũ mờ ở dưới ô input
     * Created by LTDAT(22.06.2020)
     */
    placeholder: {
      default: null,
      type: [Number, String],
    },
    // class chứa icon
    icon: {
      default: null,
      type: String,
    },
    /**
     * Số dòng
     */
    rows: {
      default: 4,
      type: Number,
    },
    // ĐVThi 09/03/2021:  bổ sung Giới hạn nhập của ô input của TextArea
    maxLength: {
      default: null,
      type: Number,
    },
    // Chặn event paste
    preventPaste: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const {errorMessage, validate} = useValidateControl({props});
    return {
      errorMessage,
      validate,
    };
  },
  data() {
    return {
      internalText: this.modelValue,
      focused: false,
    };
  },
  computed: {
    listeners() {
      return {
        blur: e => {
          this.validate();
          this.onBlur(e);
        },
        focus: e => {
          this.onFocus(e);
        },
        change: e => {
          this.$emit('change', this.internalText, e);
        },
        paste: e => this.pasteInput(e),
      };
    },
  },
  watch: {
    internalText: {
      handler(newVal, oldVal) {
        const me = this;
        me.validate(newVal);
        me.$emit('update:modelValue', newVal);
      },
    },
    modelValue: {
      immediate: true,
      handler(newVal, oldVal) {
        const me = this;
        me.setValue(newVal);
      },
    },
  },
  methods: {
    // Sự kiện focus vào ô input
    onFocus(e) {
      const me = this;
      me.focused = true;
    },
    // Sự kiên blur ra ngoài ô input
    onBlur(e) {
      const me = this;
      me.focused = false;
    },
    // Reset lại giá trị về ban đầu
    reset() {
      const me = this;
      me.internalText = null;
    },
    // Set giá trị cho ô input
    setValue(value) {
      const me = this;
      me.internalText = value;
    },
    /**
     * Xử lý paste value
     */
    pasteInput(e) {
      if (this.preventPaste) {
        e.preventDefault();
      }
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/components/MsTextArea.scss';
</style>
